module.exports = {
          srcSet: __webpack_public_path__ + "images/1909-cf8d233b381774d4c52ff14ab1626734-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1909-5fd781a678ab02433ae9e60c0c36f0e7-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1909-cf8d233b381774d4c52ff14ab1626734-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1909-5fd781a678ab02433ae9e60c0c36f0e7-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1909-cf8d233b381774d4c52ff14ab1626734-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1909-cf8d233b381774d4c52ff14ab1626734-320.jpg"},
          
          width: 320,
          height: 251
        }